import { SearchItem } from '@yiluhub/yilu-amp-types';
import { AMP_VERTICALS } from 'applicationConstants';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { getCurrentLanguage } from 'utils/i18n';
import { getURLSearchQuery } from 'utils/paramConverters';
import { getVariables } from 'utils/yiluEnv';

import routes from 'router/routes';

import { TravellerInformationFormProps } from 'components/TravellerInformationForm';

import { getEurailProductDetails } from 'modules/eurail/utils/getProductDetails';

const useReservationInformationFormProps = (
  eurailProduct: SearchItem | undefined | null,
  reservationFormRef: React.RefObject<HTMLFormElement>,
  setIsReservationUpdateLoading: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const navigate = useNavigate();
  const yiluEnv = getVariables();

  const travellerInformationFormProps = useMemo(() => {
    if (!eurailProduct) {
      return null;
    }

    const productDetails = getEurailProductDetails(eurailProduct);

    const _props: TravellerInformationFormProps<AMP_VERTICALS.EURAIL> = {
      ref: reservationFormRef,
      type: AMP_VERTICALS.EURAIL,
      shoppingCartItemRequestBody: {
        storeId: yiluEnv.YILU_AMP_STORE_ID,
        catalogId: productDetails.catalogId,
        locale: getCurrentLanguage(),
        quantity: 1,
        searchResultId: productDetails.searchResultId,
        selectedPriceId: productDetails.priceOptionId,
      },
      serviceProviderId: productDetails.serviceProvider,
      onUpdateBookingIntentSuccess(data) {
        const eurailPaymentInformationPageQueryParams = {
          searchResultID: productDetails.searchResultId,
          bookingIntentId: data.bookingIntentId,
          shoppingCartId: data.shoppingCartId,
        };

        navigate({
          pathname: routes.EURAIL_PIP,
          search: getURLSearchQuery(eurailPaymentInformationPageQueryParams),
        });
      },
      onUpdateBookingIntentRequestStateChange(isFormLoading) {
        setIsReservationUpdateLoading(isFormLoading);
      },
    };
    return _props;
  }, [
    yiluEnv.YILU_AMP_STORE_ID,
    eurailProduct,
    reservationFormRef,
    navigate,
    setIsReservationUpdateLoading,
  ]);

  return travellerInformationFormProps;
};

export default useReservationInformationFormProps;
